const PictureTitle = ({ title, date, src }) => {
    return (
        <div className="pictureTitle">
            <h2 className="title">{title}</h2>
        </div>
    )
}
export default PictureTitle;